(function($) {

	$.fn.DualSelectList = function(parameter)
	{
		// Only allow DIV to be the DualSelectList container
		if (this.length !== 1) return;
		if (this.prop('tagName') !== 'DIV') return;

		// Apply default value
		let params = $.extend({}, $.fn.DualSelectList.defaults, parameter);

		let thisMain = null;
		let thisLftPanel = null;
		let thisRgtPanel = null;
		let thisItemNull = null;

		let thisSelect = null;
		let srcEvent = null;
		let isPickup = false;
		let isMoving = false;
		let xOffset = null;
		let yOffset = null;

		this.init = function () {
			// Initialize DualSelectList content
			this.append(
				'<div class="dsl-left-title">' + params.leftTitle + '</div>' +
				'<div class="dsl-right-title">' + params.rightTitle + '</div>' +
				'<div class="dsl-panel left-panel"></div>' +
				'<div class="dsl-move-all"><i data-lucide="arrow-left-right" data-bs-toggle="tooltip" title="' + params.moveAll + '" aria-hidden="true"></i></div>' +
				'<div class="dsl-panel right-panel"></div>' +
				'<div class="dsl-panel-item-null">&nbsp;</div>'
			);

			thisMain = this;
			thisLftPanel = this.find('div.dsl-panel.left-panel');
			thisRgtPanel = this.find('div.dsl-panel.right-panel');
			thisItemNull = this.find('div.dsl-panel-item-null');

			const eventNs = '.dsl_' + (thisMain.attr('id') || Math.random().toString(36).slice(2));
			$(document).off('mousemove' + eventNs + ' mouseup' + eventNs + ' keyup' + eventNs);
			thisMain.off(eventNs);

			// append color css
			appendColorStyle();

			// Allow default Candidate and default Selection
			if(typeof(params.candidateItems) === 'string') params.candidateItems = [params.candidateItems];
			if(typeof(params.selectionItems) === 'string') params.selectionItems = [params.selectionItems];
			if (params.candidateItems.length > 0) this.setCandidate(params.candidateItems);
			if (params.selectionItems.length > 0) this.setSelection(params.selectionItems);

			function resetItemStyle(item) {
				item.css({
					'position': '',
					'z-index': '',
					'left': '',
					'top': '',
					'width': ''
				});
			}

			function finishPickup() {
				isPickup = false;
				isMoving = false;
				thisItemNull.appendTo(thisMain).hide();
				thisSelect = null;
			}

			function dropActiveItem(item) {
				let target = findItemLocation(item);
				resetItemStyle(item);
				if (target.targetFirstPosition) {
					item.prependTo(target.targetPanel);
				} else if (target.targetItem == null) {
					item.appendTo(target.targetPanel);
				} else {
					item.insertAfter(target.targetItem);
				}
			}

			// When mouse click down in one item, record this item for following actions.
			thisMain.on('mousedown' + eventNs, 'div.dsl-panel-item', function(event) {
				fixPositionProblems();
				thisSelect = $(this);
				isPickup = true;
				isMoving = false;
				srcEvent = event;
				event.preventDefault();
			});

			$(document).on('mousemove' + eventNs, function(event) {
				if (!isPickup || !thisSelect) {
					return;
				}

				if (isMoving) {
					let mainOffset = thisMain.offset();
					thisSelect.css({
						'left': event.pageX + xOffset - mainOffset.left,
						'top': event.pageY + yOffset - mainOffset.top
					});

					let target = findItemLocation(thisSelect);
					if (target.targetFirstPosition) {
						thisItemNull.prependTo(target.targetPanel).show();
					} else if (target.targetItem == null) {
						thisItemNull.appendTo(target.targetPanel).show();
					} else {
						thisItemNull.insertAfter(target.targetItem).show();
					}
				} else if (
					Math.abs(event.pageX - srcEvent.pageX) >= 2 ||
					Math.abs(event.pageY - srcEvent.pageY) >= 2
				) {
					isMoving = true;

					let srcPanel = thisSelect.parent('div.dsl-panel');
					let mainOffset = thisMain.offset();
					let itemOffset = thisSelect.offset();
					xOffset = itemOffset.left - event.pageX;
					yOffset = itemOffset.top - event.pageY;
					thisSelect.css({
						'position': 'absolute',
						'z-index': 20,
						'left': itemOffset.left - mainOffset.left,
						'top': itemOffset.top - mainOffset.top,
						'width': srcPanel.innerWidth()
					}).appendTo(thisMain);
				}
			});

			$(document).on('mouseup' + eventNs, function() {
				if (!isPickup || !thisSelect) {
					return;
				}

				if (!isMoving) {
					let srcPanel = thisSelect.parent('div.dsl-panel');
					if (srcPanel.length) {
						let tarPanel = srcPanel.hasClass('left-panel') ? thisRgtPanel : thisLftPanel;
						resetItemStyle(thisSelect);
						thisSelect.appendTo(tarPanel);
					}
				} else {
					dropActiveItem(thisSelect);
				}

				finishPickup();
			});

			$(document).on('keyup' + eventNs, function(event) {
				fixPositionProblems();
				if (isPickup && isMoving && thisSelect && event.keyCode === 27) {
					dropActiveItem(thisSelect);
					finishPickup();
				}
			});

			// When Clicking on the filter, remove the hint text
			$(document).on('focus', 'input.dsl-filter-input', function() {
				let fltText = $(this).val();
				if (fltText === 'Input Filter') {
					$(this).val('');
					$(this).css({
						'font-weight' : 'normal',
						'font-style' : 'normal',
						'color' : 'black'
					});
				}else{
					//
				}
			});

			// When leving the filter, add the hint text if there is no filter text
			$(document).on('focusout', 'input.dsl-filter-input', function() {
				let fltText = $(this).val();
				if (fltText === '') {
					$(this).val('Input Filter');
					$(this).css({
						'font-weight' : 'bolder',
						'font-style' : 'Italic',
						'color' : 'lightgray'
					});
				}else{
					//
				}
			});

			// When some text input to the filter, do filter.
			$(document).on('keyup', 'input.dsl-filter-input', function() {
				let fltText = $(this).val();
				let tarPanel = null;
				if ($(this).parent('div.dsl-filter').hasClass('left-panel')) {
					tarPanel = thisLftPanel;
				}else{
					tarPanel = thisRgtPanel;
				}

				tarPanel.find('div.dsl-panel-item').show();
				if (fltText !== '') {
					tarPanel.find('div.dsl-panel-item:not(:contains(' + fltText + '))').hide();
				}
			});
		};

		// Allow user to create the DualSelectList object first, and add candidate list later.
		this.setCandidate = function (candidate) {
			if (candidate) {
				for (let n = 0; n < candidate.length; ++n) {
					let itemStringName = $.trim(candidate[n].name.toString());
					let itemStringId = $.trim(candidate[n].id.toString());
					if (itemStringName === '') {
						continue;
					}
					thisLftPanel.append('<div class="dsl-panel-item" data-id="' + itemStringId + '">' + itemStringName + '</div>');
				}
			} else {
				thisLftPanel.html('');
			}
		};

		// Allow user to get current selection result
		this.getCandidates = function () {
			let result = [];
			let selection = thisLftPanel.find('div.dsl-panel-item');
			for (let n = 0; n < selection.length; ++n) {
				result.push({'name': selection.eq(n).html(), 'id': selection.eq(n).attr('data-id')});
			}
			return result;
		};

		// Allow user to create the DualSelectList object first, and add selection list later.
		this.setSelection = function (selection) {
			if (selection) {
				for (let n = 0; n < selection.length; ++n) {
					let itemStringName = $.trim(selection[n].name.toString());
					let itemStringId = $.trim(selection[n].id.toString());
					if (itemStringName === '') {
						continue;
					}
					thisRgtPanel.append('<div class="dsl-panel-item" data-id="' + itemStringId + '">' + itemStringName + '</div>');
				}
			} else {
				thisRgtPanel.html('');
			}
		};

		// Allow user to get current selection result
		this.getSelection = function () {
			let result = [];
			let selection = thisRgtPanel.find('div.dsl-panel-item');
			for (let n = 0; n < selection.length; ++n) {
				result.push({'name': selection.eq(n).html(), 'id': selection.eq(n).attr('data-id')});
			}
			return result;
		};

		// Allow user to change object color
		this.setColor = function (clsName, clrString) {
			clsName = $.trim(clsName);
			clrString = $.trim(clrString);
			if (!clrString) return;

			switch(clsName) {
				case 'panelBackground' :
					params.colors.panelBackground = clrString;
					break;
				case 'filterText' :
					params.colors.filterText = clrString;
					break;
				case 'itemText' :
					params.colors.itemText = clrString;
					break;
				case 'itemBackground' :
					params.colors.itemBackground = clrString;
					break;
				case 'itemHoverBackground' :
					params.colors.itemHoverBackground = clrString;
					break;
				case 'itemPlaceholderBackground' :
					params.colors.itemPlaceholderBackground = clrString;
					break;
				case 'itemPlaceholderBorder' :
					params.colors.itemPlaceholderBorder = clrString;
					break;
			}

			appendColorStyle();
		};

		// Allow user to reset object color
		this.resetColor = function (clsName) {
			clsName = $.trim(clsName);
			switch(clsName) {
				case 'panelBackground' :
					params.colors.panelBackground = '';
					break;
				case 'filterText' :
					params.colors.filterText = '';
					break;
				case 'itemText' :
					params.colors.itemText = '';
					break;
				case 'itemBackground' :
					params.colors.itemBackground = '';
					break;
				case 'itemHoverBackground' :
					params.colors.itemHoverBackground = '';
					break;
				case 'itemPlaceholderBackground' :
					params.colors.itemPlaceholderBackground = '';
					break;
				case 'itemPlaceholderBorder' :
					params.colors.itemPlaceholderBorder = '';
					break;
				case '' :
					params.colors = {
						panelBackground: '',
						filterText: '',
						itemText: '',
						itemBackground: '',
						itemHoverBackground: '',
						itemPlaceholderBackground: '',
						itemPlaceholderBorder: ''
					};
					break;
			}

			appendColorStyle();
		};

		// Function for item location calculation, not public to user.
		function findItemLocation(objItem) {
			let target = {
				targetPanel: null,
				targetItem: null,
				targetFirstPosition: false
			};

			let itemOffset = objItem.offset();
			if (!itemOffset) {
				target.targetPanel = thisLftPanel;
				return target;
			}

			let itemCenterX = itemOffset.left + objItem.outerWidth() / 2;
			let lftOffset = thisLftPanel.offset();
			let rgtOffset = thisRgtPanel.offset();
			let lftMid = lftOffset.left + thisLftPanel.outerWidth() / 2;
			let rgtMid = rgtOffset.left + thisRgtPanel.outerWidth() / 2;

			if (Math.abs(itemCenterX - lftMid) <= Math.abs(itemCenterX - rgtMid)) {
				target.targetPanel = thisLftPanel;
			} else {
				target.targetPanel = thisRgtPanel;
			}

			let itemTop = itemOffset.top;
			let candidateItems = target.targetPanel.find('div.dsl-panel-item');
			for (let n = 0; n < candidateItems.length; ++n) {
				let candidate = candidateItems.eq(n);
				if (candidate.is(objItem)) {
					continue;
				}
				let candidateTop = candidate.offset().top;
				if (itemTop > candidateTop + candidate.outerHeight() / 2) {
					target.targetItem = candidateItems[n];
				} else if (itemTop <= candidateTop && n === 0) {
					target.targetFirstPosition = true;
				}
			}

			return target;
		}

		// fix position problems
		function fixPositionProblems() {
			thisMain.children('div.dsl-panel-item').each(function() {
				let target = findItemLocation($(this));
				$(this).css({
					'position': '',
					'z-index': '',
					'left': '',
					'top': '',
					'width': ''
				});
				if (target.targetFirstPosition) {
					$(this).prependTo(target.targetPanel).show();
				} else if (target.targetItem == null) {
					$(this).appendTo(target.targetPanel).show();
				} else {
					$(this).insertAfter(target.targetItem).show();
				}
			});
		}

		// Function for item location calculation, not public to user.
		function appendColorStyle() {
			let cssContent =
				( !params.colors.panelBackground           ? '' : '.dsl-panel {background-color: ' + params.colors.panelBackground + ' !important;} ') +
				( !params.colors.filterText                ? '' : '.dsl-filter-input {color: ' + params.colors.filterText + ' !important;} ') +
				( !params.colors.itemText                  ? '' : '.dsl-panel-item {color: ' + params.colors.itemText + ' !important;} ') +
				( !params.colors.itemBackground            ? '' : '.dsl-panel-item {background-color: ' + params.colors.itemBackground + ' !important;} ') +
				( !params.colors.itemHoverBackground       ? '' : '.dsl-panel-item:hover {background-color: ' + params.colors.itemHoverBackground + ' !important;} ') +
				( !params.colors.itemPlaceholderBackground ? '' : '.dsl-panel-item-null {background-color: ' + params.colors.itemPlaceholderBackground + ' !important;} ') +
				( !params.colors.itemPlaceholderBorder     ? '' : '.dsl-panel-item-null {border-color: ' + params.colors.itemPlaceholderBorder + ' !important;} ') ;
			$('#dual-select-list-style').remove();
			if (cssContent) $('html>head').append($('<style id="dual-select-list-style">' + cssContent + ' </style>'));
		}

		this.init();
		return this;
	};

	$.fn.DualSelectList.defaults = {
		candidateItems: [],
		selectionItems: [],
		colors: {
			panelBackground: '',
			filterText: '',
			itemText: '',
			itemBackground: '',
			itemHoverBackground: '',
			itemPlaceholderBackground: '',
			itemPlaceholderBorder: ''
		}
	};

})(jQuery);
